import { Button, Modal } from "antd";
import axios from "axios";
import style from "css/menu.module.css";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";

export default function ResDetailPop({
  isOpenResDetail,
  close,
  openRes,
  schedule,
  getScheduleList,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const closePop = () => {
    close();
  };

  const handleJoin = (link) => {
    window.open(link);
  };

  const handleDelete = () => {
    let config = {
      params: {
        PROCESS_TYPE: "D",
        SCHEDULE_ID: schedule.SCHEDULE_ID,
        SCHEDULE_TYPE: schedule.SCHEDULE_TYPE,
        TITLE: schedule.TITLE,
        RECORD_YN: schedule.RECORD_YN,
        START_TIME: dayjs(schedule.START_TIME).format("YYYY-MM-DD HH:mm:ss"),
        END_TIME: dayjs(schedule.END_TIME).format("YYYY-MM-DD HH:mm:ss"),
      },
    };

    axios
      .delete("/schedule/reserve", config)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.DELETE_COMPLETE"),
            submitEventHandler: () => {
              getScheduleList();
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          closePop();
        }
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };

  return (
    <Modal
      className={style.res_detail_popup} //모달 ClassName
      open={isOpenResDetail}
      onCancel={closePop}
      maskClosable={false}
      footer={null}
    >
      <div className={style.res_detail_popup_wrap}>
        <div className={style.res_detail_popup_container}>
          <article className={style.res_detail_header}>
            <p className={style.res_detail_title}>
              {/* {t("LABEL.TITLE.MEETING_DETAILS")} */}
              ResDetailPop
            </p>
          </article>
          <div className={style.res_detail_meeting_title}>{schedule.TITLE}</div>
          <ul className={style.res_detail_body}>
            <li>
              <div className={style.res_detail_info_type}>
                {t("LABEL.MEETING_START")}
              </div>

              <div
                className={style.res_detail_info_value}
                id="detail_conf_title_confirm"
              >
                {dayjs(schedule.START_TIME).format("YYYY-MM-DD ddd - HH:mm A")}
              </div>
            </li>

            <li>
              <div className={style.res_detail_info_type}>
                <p>{t("LABEL.MEETING_END")}</p>
              </div>

              <div
                className={style.res_detail_info_value}
                id="detail_conf_date_confirm"
              >
                {dayjs(schedule.END_TIME).format("YYYY-MM-DD ddd - HH:mm A")}
              </div>
            </li>

            <li>
              <div className={style.res_detail_info_type}>
                <p>{t("LABEL.MEETING_HOST")}</p>
              </div>

              <div className={style.res_detail_info_value} id="res_detail_host">
                {schedule.HOST_NM}
              </div>
            </li>

            <li>
              <div className={style.res_detail_info_type}>
                <p>{t("LABEL.MEETING_PTCP")}</p>
              </div>

              <div className={style.res_detail_info_value}>
                <div className={style.res_detail_prtcp_list}>
                  {(schedule.PARTICIPANT_LIST || []).map((item, index) => (
                    <div key={index}>{item.MEMBER_NM}</div>
                  ))}
                </div>
              </div>
            </li>

            <li>
              <div className={style.res_detail_info_type}>
                <p>{t("LABEL.MEETING_CONTENT")}</p>
              </div>

              <div
                className={style.res_detail_info_value}
                id="detail_conf_contents_confirm"
              >
                {schedule.CONTENTS}
              </div>
            </li>

            <li>
              <div className={style.res_detail_info_type}>
                <p>{t("LABEL.MEETING_ROOM")}</p>
              </div>

              <div className={style.res_detail_info_value}>
                <div
                  className={style.res_detail_endpoint_list}
                  id="res_detail_endpoint_list"
                >
                  {(schedule.ENDPOINT_LIST || []).map((item, index) => (
                    <div key={index}>{item.ENDPOINT_NM}</div>
                  ))}
                </div>
              </div>
            </li>

            <li>
              <div className={style.res_detail_info_type}>
                <p>{t("LABEL.ATTACHMENT")}</p>
              </div>

              <div
                className={style.res_detail_info_value}
                id="detail_conf_contents_confirm"
              >
                {/* {schedule.CONTENTS} */}
              </div>
            </li>
          </ul>

          <div className={style.res_detail_btn}>
            <Button
              type="primary"
              className={style.res_detail_btn_delete}
              onClick={handleDelete}
            >
              {t("BTN.DELETE")}
            </Button>
            <Button
              type="primary"
              className={style.res_detail_btn_update}
              onClick={() => {
                openRes(schedule);
                closePop();
              }}
            >
              {t("BTN.MODIFY")}
            </Button>
            <Button
              type="primary"
              className={style.res_detail_btn_join}
              onClick={() => handleJoin(schedule.MEETING_URL)}
            >
              {t("BTN.JOIN")}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
